module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "post-selector"
  }, _vm._l((_vm.posts.length), function(n) {
    return _c('div', {
      class: ['item', {
        'selected': n - 1 === _vm.selectedPost
      }],
      on: {
        "click": function($event) {
          _vm.selectPost(n)
        }
      }
    }, [(_vm.posts[n - 1].mediaData.mediaType === 'Image') ? _c('div', {
      staticClass: "icon-button",
      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.mediaUrl) + "');"))
    }) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Video') ? _c('div', {
      staticClass: "icon-button"
    }, [_c('i', {
      staticClass: "fas fa-video-camera"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Youtube') ? _c('div', {
      staticClass: "icon-button",
      style: (_vm.generateYoutubeBackgroundImageStyle(_vm.posts[n - 1].mediaData.mediaUrl))
    }, [_c('i', {
      staticClass: "fab fa-youtube"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'External' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button"
    }, [_c('i', {
      staticClass: "fas fa-link xo"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Archive' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button"
    }, [_c('i', {
      staticClass: "fas fa-archive xo"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Audio' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button"
    }, [_c('i', {
      staticClass: "fas fa-volume-up xo"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Flash' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button"
    }, [_c('i', {
      staticClass: "fas fa-rocket xo"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Text' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button"
    }, [_c('i', {
      staticClass: "fas fa-book xo"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'External' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button",
      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
    }, [_c('i', {
      staticClass: "fas fa-link"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Archive' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button",
      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
    }, [_c('i', {
      staticClass: "fas fa-archive"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Audio' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button",
      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
    }, [_c('i', {
      staticClass: "fas fa-volume-up xy"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Flash' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button",
      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
    }, [_c('i', {
      staticClass: "fas fa-rocket"
    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Text' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
      staticClass: "icon-button",
      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
    }, [_c('i', {
      staticClass: "fas fa-book"
    })]) : _vm._e()])
  })), _vm._v(" "), _c('feed-status-post', {
    key: _vm.posts[_vm.selectedPost].id,
    attrs: {
      "data": _vm.posts[_vm.selectedPost]
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a018d89e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/FeedPosts/FeedGroupPost.vue
// module id = 905
// module chunks = 2